import {
    Alert,
    Collapse,
    Dropdown,
    Modal,
    Tab,
    Tooltip,
    Popover
} from 'bootstrap';
import AOS from 'aos';
import axios from 'axios';
import CookieNotification from "bb-cookie-notification";
import Flickity from 'flickity';

// Init Animate On Scroll
AOS.init();

// BenedenBoven cookiescript
new CookieNotification();

// Remove background-img border
document.querySelectorAll('img:not([src])').forEach((element) => {
    element.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
});

// Enable BS Tooltips everywhere
var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList        = tooltipTriggerList.map(function(tooltipTriggerEl) {
    return new Tooltip(tooltipTriggerEl)
});

if(document.querySelector('.faq-carousel')) {
    const flkty = new Flickity('.faq-carousel', {
        cellAlign:       'left',
        contain:         true,
        prevNextButtons: true,
        pageDots:        true,
        freeScroll:      true,
        groupCells:      true
    });
}

document.querySelectorAll('.send-form').forEach((form) => {
    form.addEventListener('submit', (e) => {
        e.preventDefault();

        const submitButton = form.querySelector('[type="submit"]');
        submitButton.classList.add('disabled');
        submitButton.disabled  = true;
        submitButton.innerHTML = '<div class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden">Loading...</span></div>';

        const formData = new FormData(form);
        grecaptcha.ready(function() {
            grecaptcha.execute(document.querySelector('meta[name="grecaptcha-site-key"]').content, { action: 'submit' }).then(function(token) {
                formData.append('g-recaptcha-response', token);


                const validationAlert = form.parentNode.querySelector('.alert');
                validationAlert.classList.add('hidden');
                validationAlert.classList.remove('alert-danger');

                document.querySelectorAll('.invalid-feedback').forEach((element) => {
                    if(!element.classList.contains('d-none')) {
                        element.classList.add('d-none');
                    }
                });

                document.querySelectorAll('.is-invalid').forEach((element) => {
                    element.classList.remove('is-invalid');
                });

                axios.post(form.action, formData).then((response) => {
                    if(response.data.success) {
                        validationAlert.innerHTML = response.data.message;
                        validationAlert.classList.add('alert-success');
                        validationAlert.classList.remove('d-none');

                        form.innerHTML = '';
                    }
                }).catch((exception) => {
                    if(exception.response.data.errors) {
                        for(let error in exception.response.data.errors) {
                            const el = form.querySelector('[name="' + error + '"]');
                            el.classList.add('is-invalid');
                            if(el.parentNode.querySelector('.d-none') !== null) {
                                el.parentNode.querySelector('.d-none').classList.remove('d-none');
                            }
                        }
                    }

                    submitButton.classList.remove('disabled');
                    submitButton.disabled  = false;
                    submitButton.innerHTML = 'Verstuur bericht';
                });
            });
        });
    });
});

// Add and remove class on scroll
if(document.querySelector('nav')) {
    let scrollpos      = window.scrollY
    const header       = document.querySelector("nav")
    const headerHeight = header.offsetHeight

    const addClassOnScroll    = () => header.classList.add("navbar-shrink")
    const removeClassOnScroll = () => header.classList.remove("navbar-shrink")

    window.addEventListener('scroll', (event) => {
        scrollpos = window.scrollY;

        if(scrollpos >= headerHeight) {
            addClassOnScroll()
        } else {
            removeClassOnScroll()
        }
    });
}

// Splashscreen logo
if(document.querySelector('.logo-splash')) {
    var splash = document.querySelector(".logo-splash");

    window.addEventListener("load", (event) => {
        setTimeout(() => {
            splash.classList.remove("is-visible");
        }, 1500);
    });
}
